import { PlayerStatsOptionValues } from '../../constants';
import type { PlayerStatsOption } from '../../types';

import PlayerStatsHeader from './PlayersStatsHeader';
import PlayerStatGoalRow from './PlayerStatRow/PlayerStatGoalRow';
import PlayerStatAssistRow from './PlayerStatRow/PlayerStatAssistRow';
import PlayerStatShotRow from './PlayerStatRow/PlayerStatShotRow';
import PlayerStatCardRow from './PlayerStatRow/PlayerStatCardRow';
import PlayerStatInjuredRow from './PlayerStatRow/PlayerStatInjuredRow';
import type { PlayerData } from './PlayersStats.types';

interface PlayersStatsProps {
  activeFilter: PlayerStatsOption;
  playersData: PlayerData[];
}

export default function PlayersStats({ activeFilter, playersData }: PlayersStatsProps) {
  const renderPlayerRow = (playerData: PlayerData) => {
    switch (activeFilter) {
      case PlayerStatsOptionValues.GOALS:
        return (
          <PlayerStatGoalRow
            key={`${playerData.name}-${playerData.position}-${playerData.goals}`}
            playerData={playerData}
          />
        );
      case PlayerStatsOptionValues.ASSISTS:
        return (
          <PlayerStatAssistRow
            key={`${playerData.name}-${playerData.position}-${playerData.assists}`}
            playerData={playerData}
          />
        );
      case PlayerStatsOptionValues.SHOTS:
        return (
          <PlayerStatShotRow
            key={`${playerData.name}-${playerData.position}-${playerData.shotsOnTarget}-${playerData.shotsOffTarget}`}
            playerData={playerData}
          />
        );
      case PlayerStatsOptionValues.CARDS:
        return (
          <PlayerStatCardRow
            key={`${playerData.name}-${playerData.position}-${playerData.yellowCards}-${playerData.redCards}`}
            playerData={playerData}
          />
        );
      case PlayerStatsOptionValues.INJURED:
        return (
          <PlayerStatInjuredRow
            key={`${playerData.name}-${playerData.position}-${playerData.injury}`}
            playerData={playerData}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="grid grid-cols-[[player-info]_minmax(120px,1fr)_[gap]_0.5rem_[stat-1]_auto_[separator]_auto_[stat-2]_auto] items-center gap-y-1">
      <PlayerStatsHeader activeFilter={activeFilter} />
      <div className="col-span-5 grid grid-cols-subgrid gap-y-3">
        {playersData.map(renderPlayerRow)}
      </div>
    </div>
  );
}
